module.exports = __webpack_public_path__ + "img/catering2.93673341.jpg";